var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizeOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n\n      .st2 {\n        fill: #f95108;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 9.35,
    y: 8,
    width: 21.3,
    height: 24
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20,
    cy: 20,
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.85,14.4h5.5v7h-5.5c-.8,0-1.4-.6-1.4-1.4v-4.1c-.1-.8.6-1.5,1.4-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.75,15.9v4.1c0,.8-.6,1.4-1.4,1.4h-5.5v-7h5.5c.7,0,1.4.7,1.4,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.05,22.8h5.3v9.2h-4c-.7,0-1.3-.6-1.3-1.3v-7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.05,22.8v7.9c0,.7-.6,1.3-1.3,1.3h-4v-9.2h5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.25,14.4h-4.4v17.6h4.4s0-17.6,0-17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.35,13.5h-3.7c-.4,0-.7-.2-.9-.6s-.1-.8.1-1.1l2.3-2.8c.5-.6,1.3-1,2.2-1,1.5,0,2.8,1.2,2.8,2.8s-1.3,2.7-2.8,2.7ZM23.75,11.5h1.6c.4,0,.8-.3.8-.8s-.4-.7-.8-.7c-.2,0-.5.1-.6.3l-1,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.45,13.5h-3.7c-1.5,0-2.8-1.2-2.8-2.8s1.3-2.7,2.8-2.7c.9,0,1.7.4,2.2,1.1l2.2,2.7c.2.3.3.7.1,1.1-.1.4-.4.6-.8.6ZM14.75,10c-.4,0-.8.3-.8.8s.3.8.8.8h1.6l-1-1.2c-.1-.3-.4-.4-.6-.4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeOrange);
export default __webpack_public_path__ + "static/media/prize-orange.97bcd905b71a5528661cb82b5593afe5.svg";
export { ForwardRef as ReactComponent };